import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: null,
  role: null,
  userIsAuthenticated: false,
  claims: null,
};

export const userProfile = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.userIsAuthenticated = action.payload.userIsAuthenticated;
      state.claims = action.payload.claims;
    },
  },
});

export const { setProfile } = userProfile.actions;

export const selectClaim = (state: any) => state.userProfile.claims;

export default userProfile.reducer;
